import React from 'react';
// import HeaderWithSidebar from '../HeaderWithSidebar'
import { useRouter } from 'next/router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Head from 'next/head';
import { Container, LogoContainer, Content } from './style';
import Link from '../../atoms/Link';
import Image from '../../atoms/Image';
import Button from '../../atoms/Button';
import { useTranslation } from '../../../config/i18n';
var Logo = '/images/mubazar-logo-BETA-RED.png';

// import Button

var ErrorTemplate = function ErrorTemplate(_ref) {
  var children = _ref.children,
    title = _ref.title;
  var _useTranslation = useTranslation('common'),
    t = _useTranslation.t;
  var router = useRouter();
  var handleBackClick = function handleBackClick() {
    router.back();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, [/*#__PURE__*/React.createElement(Head, {
    key: 'head'
  }, /*#__PURE__*/React.createElement('title', null, "Mubazar - ".concat(title))), /*#__PURE__*/React.createElement(Container, {
    key: 'container'
  }, [/*#__PURE__*/React.createElement(Content, {
    key: 'content'
  }, children), /*#__PURE__*/React.createElement(Button, {
    key: 'button',
    startIcon: /*#__PURE__*/React.createElement(ArrowBackIcon),
    variant: 'outlined',
    color: 'primary',
    onClick: handleBackClick
  }, t('common:back')), /*#__PURE__*/React.createElement(LogoContainer, {
    key: 'logo'
  }, /*#__PURE__*/React.createElement(Link, {
    href: '/',
    color: 'inherit'
  }, /*#__PURE__*/React.createElement(Image, {
    bottom: '0.3125rem',
    width: '15rem',
    src: Logo
  })))])]);
};
export default ErrorTemplate;